import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import JobProgressLoader from 'components/job-progress -loader/JobProgressLoader';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { JobProgressStatus } from 'constants/JobProgress';

export const defaultActionWithProgressBar = ({ service, title, value }) => {
    return props => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id } = params;

        const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);
        const [isSuccess, setIsSuccess] = useState(false);

        const [requestId, setRequestId] = useState('');

        const [loading, setLoading] = useState(false);

        const handleOpenConfirmationModal = event => {
            event.stopPropagation();
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };

        const handleConfirm = async event => {
            event.stopPropagation();
            try {
                setLoading(true);
                const response = await service(id);
                const jobTaskId = response?.hasOwnProperty('requestId')
                    ? response?.requestId
                    : response?.data.requestId;
                setLoading(false);
                if (!jobTaskId) throw new Error('Action not completed.');
                if (!!jobTaskId) {
                    setRequestId(jobTaskId);
                    setIsSuccess(true);
                } else {
                    enqueueSnackbar('Action completed successfully.', {
                        variant: 'success',
                    });
                }
            } catch (err) {
                enqueueSnackbar(err.message, { variant: 'error' });
            } finally {
                setLoading(false);
            }
        };
        const onFinish = status => {
            try {
                if (status === JobProgressStatus?.Failed)
                    throw new Error('Action not completed.');
                enqueueSnackbar('Action completed successfully.', {
                    variant: 'success',
                });
                setIsSuccess(false);
            } catch (err) {
                enqueueSnackbar(err.message, { variant: 'error' });
            } finally {
                setIsSuccess(false);
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={handleCloseConfirmationModal}
                                variant="outlined"
                                color="secondary"
                            >
                                Close
                            </Button>
                        </>
                    )}
                >
                    {isSuccess && requestId ? (
                        <JobProgressLoader
                            requestId={requestId}
                            onFinish={onFinish}
                            isLinear={true}
                        />
                    ) : (
                        <Stack spacing={2} direction="column">
                            <LoadingButton
                                variant="contained"
                                size={'small'}
                                onClick={event => handleConfirm(event)}
                                loading={loading}
                            >
                                <span>Confirm</span>
                            </LoadingButton>
                        </Stack>
                    )}
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={title}
                    onClick={event => handleOpenConfirmationModal(event)}
                    {...restProps}
                    aria-hidden="false"
                >
                    {title}
                </MenuItem>
            </>
        );
    };
};
